export default __webpack_public_path__ + "static/media/fox_not_found.10dc0154.png";